import { Logger } from 'tslog';

import { environment } from '@ts/shared/util-environment';

export const logger = new Logger({
  name: 'default',
  minLevel: environment.logLevel,
});
